/* Source: /app/components/Controllers/debug-control.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { cn } from "../../lib/utils.js";
import { Play, SkipForward, ArrowDown, ArrowUp, RotateCw, Square, StepForward, StepBack } from "lucide-react";
function DebugButton(props) {
  let onClick = props.onClick;
  let icon = props.icon;
  let label = (props.label || "");
  let variant = (props.variant || "default");
  let disabled = (props.disabled || false);
  let variantClasses = {"default": "text-text-secondary hover:bg-background hover:text-text-primary", "danger": "text-error hover:bg-error/10", "warning": "text-warning hover:bg-warning/10", "primary": "text-primary hover:bg-primary/10"};
  return __jacJsx("button", {"onClick": onClick, "disabled": disabled, "title": label, "className": cn("flex items-center gap-1 px-2 py-1.5 rounded-md text-xs transition-all", "disabled:opacity-50 disabled:cursor-not-allowed", (variantClasses[variant] || variantClasses["default"]))}, [icon]);
}
function DebugController(props) {
  let onContinue = props.onContinue;
  let onStepOver = props.onStepOver;
  let onStepIn = props.onStepIn;
  let onStepOut = props.onStepOut;
  let onRestart = props.onRestart;
  let onStop = props.onStop;
  let isRunning = (props.isRunning || false);
  let className = (props.className || "");
  let onhandleDebugAction = props.onhandleDebugAction;
  return __jacJsx("div", {"className": cn("inline-flex items-center gap-0.5", className)}, [__jacJsx(DebugButton, {"icon": __jacJsx(Play, {"size": 14}, []), "label": "Continue (F5)", "onClick": () => {
    onhandleDebugAction("continue");
  }, "variant": "primary"}, []), __jacJsx(DebugButton, {"icon": __jacJsx(StepForward, {"size": 14}, []), "label": "Step Over (F10)", "onClick": () => {
    onhandleDebugAction("stepOver");
  }, "variant": "default"}, []), __jacJsx(DebugButton, {"icon": __jacJsx(StepBack, {"size": 14}, []), "label": "Step Into (F11)", "onClick": () => {
    onhandleDebugAction("stepInto");
  }, "variant": "default"}, []), __jacJsx(DebugButton, {"icon": __jacJsx(ArrowUp, {"size": 14}, []), "label": "Step Out (Shift+F11)", "onClick": () => {
    onhandleDebugAction("stepOut");
  }, "variant": "default"}, []), __jacJsx(DebugButton, {"icon": __jacJsx(RotateCw, {"size": 14}, []), "label": "Restart (Ctrl+Shift+F5)", "onClick": () => {
    onhandleDebugAction("restart");
  }, "variant": "warning"}, []), __jacJsx(DebugButton, {"icon": __jacJsx(Square, {"size": 14}, []), "label": "Stop (Shift+F5)", "onClick": () => {
    onhandleDebugAction("stop");
  }, "variant": "danger"}, [])]);
}
export {DebugButton, DebugController};